export function getOriginFromUrl (url: string): string {
    try {
        const urlObj = new URL(url)
        return urlObj.origin
    } catch (error) {
        console.error('Invalid URL:', error)
        return ''
    }
}
